import { createContext, useContext } from 'react'

export const AuthContext = createContext(null)

/**
 * `{ session, expired, login, logout }`. `session` is null when signed out;
 * `expired` is true when the last sign-out was the one-hour token running out.
 */
export function useAuth() {
  const value = useContext(AuthContext)
  if (!value) throw new Error('useAuth must be used inside <AuthProvider>')
  return value
}
